import { Icon } from '@iconify/react';
import {
  Autocomplete,
  Box,
  Button,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { styled } from '@mui/system';
import { BackgroundModal } from 'components/CashModal/CashModal';
import React, { useEffect, useState } from 'react';
import closeIcon from '@iconify/icons-eva/close-outline';
import useDebounce from 'hook/useDebounce';
import useQuery from 'hook/useQuery';
import { API_PATH } from 'common/constants/services';
import UserSimpleInfo from 'model/UserSimpleInfo';
import { Pagination } from 'model/Pagination';
import useMutation, { METHOD } from 'hook/useMutation';
import { useQueryClient } from 'react-query';
import { CoachUser } from 'model/Settlements';
import { RootStyle } from './style';

interface IProps {
  isOpen: boolean;
  close: () => void;
  coach?: CoachUser;
}
const Container = styled('div')`
  width: 474px;
  background-color: white;

  position: absolute;
  width: 474px;
  left: calc(50% - 474px / 2);
  top: calc(50% - 476px / 2);

  border-radius: 12px;
`;

export function EditCoachModal({ isOpen, close, coach }: IProps) {
  const [nickname, setNickname] = useState('');
  const [userId, setUserId] = useState<number | undefined>(undefined);
  const [name, setName] = useState('');
  const nicknameDebounce = useDebounce(nickname, 200);
  const queryClient = useQueryClient();
  const userListQuery = useQuery<Pagination<UserSimpleInfo>>(
    API_PATH.USER_FIND,
    {
      nickname: nicknameDebounce,
    },
  );
  const editMutation = useMutation(API_PATH.COACHES, {
    method: METHOD.PATCH,
    onSuccess: () => {
      queryClient.invalidateQueries([API_PATH.COACHES]);
    },
  });
  const userOption = userListQuery.getQuery.data?.data.results.map((user) => ({
    id: user.id,
    label: user.nickname,
  }));
  useEffect(() => {
    setName(coach?.name || '');
  }, [coach]);
  return isOpen ? (
    <BackgroundModal isOpen={isOpen} onClick={close}>
      <Container
        onClick={(event: any) => {
          event.stopPropagation();
        }}
      >
        <Stack direction='row' padding={3}>
          <Box flex={1}>
            <Typography fontSize={22} fontWeight={700}>
              코치 수정하기
            </Typography>
          </Box>
          <Icon icon={closeIcon} fontSize={24} onClick={close} />
        </Stack>
        <Stack padding={3} direction='column' spacing={2}>
          <Box width='100%'>
            <TextField
              fullWidth
              id='outlined-helperText'
              label='코치 이름(구분용)'
              defaultValue=''
              placeholder='코치이름을 입력하세요'
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Box>
          <Box width='100%'>
            <TextField
              fullWidth
              id='outlined-helperText'
              label='짐워크 닉네임'
              defaultValue=''
              placeholder='코치이름을 입력하세요'
              value={coach?.nickname}
              disabled
            />
          </Box>
        </Stack>
        <Stack padding={3}>
          <Button
            variant='contained'
            fullWidth
            disabled={name === ''}
            onClick={async () => {
              await editMutation.mutateAsync({
                user_id: coach?.user_id,
                name,
              });
              close();
            }}
          >
            수정하기
          </Button>
        </Stack>
      </Container>
    </BackgroundModal>
  ) : null;
}
